"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyRoutes = void 0;
exports.companyRoutes = [
    {
        name: 'company.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'company.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'company.preview',
        path: ['/preview/:id', '/preview'],
        method: 'GET'
    },
    {
        name: 'company.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'company.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'company.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
